import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Logo } from "@/components/Logo";

export const Nav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const goToSection = (hash) => (e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.__lenis?.scrollTo(hash, { offset: -70 });
    } else {
      navigate(`/${hash}`);
    }
  };

  return (
    <motion.header
      initial={{ y: -70, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.15 }}
      className="fixed inset-x-0 top-0 z-50"
      data-testid="site-nav"
    >
      <div className="glass mx-3 mt-3 rounded-2xl px-4 py-3 sm:mx-6 sm:px-6">
        <div className="flex items-center justify-between">
          <Link to="/" aria-label="JomKonvoi home" data-testid="nav-logo-link">
            <Logo />
          </Link>
          <nav className="flex items-center gap-6 sm:gap-8" data-testid="nav-links">
            <a
              href="/#how-it-works"
              onClick={goToSection("#how-it-works")}
              className="label-tech text-neutral-400 transition-colors duration-300 hover:text-white"
              data-testid="nav-how-it-works-link"
            >
              How it works
            </a>
            <a
              href="/#the-app"
              onClick={goToSection("#the-app")}
              className="label-tech hidden text-neutral-400 transition-colors duration-300 hover:text-white sm:block"
              data-testid="nav-the-app-link"
            >
              The app
            </a>
            <a
              href="/#faq"
              onClick={goToSection("#faq")}
              className="label-tech hidden text-neutral-400 transition-colors duration-300 hover:text-white sm:block"
              data-testid="nav-faq-link"
            >
              FAQ
            </a>
            <Link
              to="/legal"
              className="label-tech text-neutral-400 transition-colors duration-300 hover:text-white"
              data-testid="nav-legal-link"
            >
              Legal
            </Link>
          </nav>
        </div>
      </div>
    </motion.header>
  );
};
